import { css } from '@emotion/react';
import { GlobalStyles } from '@mui/joy';
import type { MapMouseEvent } from '@vis.gl/react-maplibre';
import { useCallback, useState } from 'react';

import { useMapOnEvent } from '@/hooks/useMapOnEvent';
import { useCreateReportStore } from '@/stores/useCreateReportStore';
import { LocationInputMode } from '@/types/LocationInputMode';

interface LayerHoverCursorStyleProps {
  layers: string[];
}

export function LayerHoverCursorStyle({ layers }: LayerHoverCursorStyleProps) {
  const [isHovering, setIsHovering] = useState(false);

  const locationInputMode = useCreateReportStore((state) => state.locationInputMode);

  const handleMouseMove = useCallback(
    ({ target, point }: MapMouseEvent) => {
      const availableLayers = layers.filter((layer) => !!target.getLayer(layer));
      const features = availableLayers.length > 0 && target.queryRenderedFeatures(point, { layers: availableLayers });

      if (features && features.length > 0) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    },
    [layers],
  );

  useMapOnEvent({
    type: 'mousemove',
    listener: handleMouseMove,
  });

  if (locationInputMode !== LocationInputMode.MAP && isHovering) {
    return (
      <GlobalStyles
        styles={css`
          .maplibregl-canvas {
            cursor: pointer;
          }
        `}
      />
    );
  }

  return null;
}
